import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs'
import WhatsAppTemplateList from './WhatsAppTemplateList';
import SMSTemplateList from './SMSTemplateList'
import EmailTemplateList from './EmailTemplateList'
import TemplateRegisterController from '../../../../Controllers/AdminScreens/Configuration/TemplateCenter/TemplateRegisterController';


const TemplateRegisterScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };

    const {
        whatsAppData,
        whatsAppError,
        whatsAppLoading,

        emailData,
        emailError,
        emailLoading,

        smsData,
        smsError,
        smsLoading,
        refreshHandlers,
        whatsAppStatus,
        tabs,
        employeeList,
        empLoading,
        empError,
    } = TemplateRegisterController();

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 10 }}>
                <h2 className='title'>Template Register</h2>
            </div>

            <div >
                <Tabs tabs={tabs}
                    selectedIndex={selectedTab}
                    onTabChange={handleTabChange}>
                    {tabs.map((tab) => {
                        switch (tab) {
                            case 'WhatsApp':
                                return (
                                    <WhatsAppTemplateList
                                        key="whatsapp"
                                        data={whatsAppData}
                                        loading={whatsAppLoading}
                                        error={whatsAppError}
                                        refreshHandlers={refreshHandlers}
                                        employeeList={employeeList}
                                        empLoading={empLoading}
                                        empError={empError}
                                    />
                                );
                            case 'Email':
                                return (
                                    <EmailTemplateList
                                        key="email"
                                        data={emailData}
                                        loading={emailLoading}
                                        error={emailError}
                                        refreshHandlers={refreshHandlers}
                                        employeeList={employeeList}
                                        empLoading={empLoading}
                                        empError={empError}
                                    />
                                );
                            case 'SMS':
                                return (
                                    <SMSTemplateList
                                        key="sms"
                                        data={smsData}
                                        loading={smsLoading}
                                        error={smsError}
                                        refreshHandlers={refreshHandlers}
                                        employeeList={employeeList}
                                        empLoading={empLoading}
                                        empError={empError}
                                    />
                                );
                            default:
                                return null;
                        }
                    })}
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default TemplateRegisterScreen;